import * as React from 'react';
import {Redirect, Switch} from 'react-router-dom';

// We are redirecting all of the old email-marketing routes to catch any in-app links to deprecated routes
// original routes can be found in email-marketing-root.js
export const EmailMarketingRedirectRoutes = () => (
    <Switch>
        <Redirect
            exact={true}
            from='/email-marketing/newsletters'
            to='/marketing/email/newsletters'
        />
        <Redirect
            exact={true}
            from='/email-marketing/newsletters/:newsletterId'
            to='/marketing/email/newsletters/:newsletterId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/newsletters/:newsletterId/:tab'
            to='/marketing/email/newsletters/:newsletterId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/newsletters/:newsletterId/editions/:editionId'
            to='/marketing/email/newsletters/:newsletterId/editions/:editionId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/newsletters/:newsletterId/editions/:editionId/:tab'
            to='/marketing/email/newsletters/:newsletterId/editions/:editionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/broadcasts'
            to='/marketing/email/broadcasts'
        />
        <Redirect
            exact={true}
            from='/email-marketing/broadcasts/archived'
            to='/marketing/email/broadcasts'
        />
        <Redirect
            exact={true}
            from='/email-marketing/broadcasts/:broadcastId/editions/:editionId'
            to='/marketing/email/broadcasts/:broadcastId/editions/:editionId/editor'
        />
        <Redirect
            exact={true}
            from='/email-marketing/broadcasts/:broadcastId/editions/:editionId/:tab'
            to='/marketing/email/broadcasts/:broadcastId/editions/:editionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/broadcasts'
            to='/marketing/sms/broadcasts'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/broadcasts/:broadcastId/editions/:editionId'
            to='/marketing/sms/broadcasts/:broadcastId/editions/:editionId/details'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/broadcasts/:broadcastId/editions/:editionId/:tab'
            to='/marketing/sms/broadcasts/:broadcastId/editions/:editionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/drip-sequences'
            to='/marketing/sms/drip-sequences'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/:tab'
            to='/marketing/sms/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId'
            to='/marketing/sms/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/sms/drip-sequences/:dripSequenceId/'
            to='/marketing/sms/drip-sequences/:dripSequenceId/'
        />
        <Redirect exact={true} from='/email-marketing/forms' to='/marketing/forms' />
        <Redirect
            exact={true}
            from='/email-marketing/forms/:formId'
            to='/marketing/forms/:formId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/forms/:formId/preview'
            to='/marketing/forms/:formId/preview'
        />
        <Redirect
            exact={true}
            from='/email-marketing/forms/:formId/:tab'
            to='/marketing/forms/:formId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/connected-forms'
            to='/marketing/connected-forms'
        />
        <Redirect
            exact={true}
            from='/email-marketing/connected-forms/:formId'
            to='/marketing/connected-forms/:formId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/connected-forms/:formId/:tab'
            to='/marketing/connected-forms/:formId/:tab'
        />
        <Redirect exact={true} from='/email-marketing/analytics' to='/marketing/analytics' />
        <Redirect exact={true} from='/email-marketing/visitors' to='/marketing/visitors' />
        <Redirect
            exact={true}
            from='/email-marketing/visitors/:tab'
            to='/marketing/visitors/:tab'
        />
        <Redirect exact={true} from='/email-marketing/competitors' to='/marketing/competitors' />
        <Redirect
            exact={true}
            from='/email-marketing/competitors/:tab'
            to='/marketing/competitors/:tab'
        />
        <Redirect exact={true} from='/email-marketing/prospector' to='/marketing/prospector' />
        <Redirect
            exact={true}
            from='/email-marketing/digital-marketing-services'
            to='/marketing/digital-marketing-services'
        />
        <Redirect exact={true} from='/email-marketing/seo-scan' to='/marketing/seo-scan' />
        <Redirect
            exact={true}
            from='/email-marketing/marketing-resources'
            to='/marketing/email/marketing-resources'
        />
        <Redirect
            exact={true}
            from='/email-marketing/crm-advertising'
            to='/marketing/crm-advertising'
        />
        <Redirect exact={true} from='/email-marketing/templates' to='/marketing/email/templates' />
        <Redirect
            exact={true}
            from='/email-marketing/templates/:templateId/editions/:editionId/editor'
            to='/marketing/email/templates/:templateId/editions/:editionId/editor'
        />
        <Redirect
            exact={true}
            from='/email-marketing/templates/:templateId/editions/:editionId'
            to='/marketing/email/templates/:templateId/editions/:editionId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/templates/:templateId/editions/:editionId/:tab'
            to='/marketing/email/templates/:templateId/editions/:editionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences'
            to='/marketing/email/drip-sequences'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences/:dripSequenceId'
            to='/marketing/email/drip-sequences/:dripSequenceId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences/:dripSequenceId/:tab'
            to='/marketing/email/drip-sequences/:dripSequenceId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/editor'
            to='/marketing/email/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/editor'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId'
            to='/marketing/email/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/:tab'
            to='/marketing/email/drip-sequences/:dripSequenceId/editions/:dripSequenceEditionId/:tab'
        />
        <Redirect
            exact={true}
            from='/email-marketing/landing-pages'
            to='/marketing/landing-pages'
        />
        <Redirect
            exact={true}
            from='/email-marketing/landing-pages/:pageId'
            to='/marketing/landing-pages/:pageId'
        />
        <Redirect
            exact={true}
            from='/email-marketing/landing-pages/:pageId/:tab'
            to='/marketing/landing-pages/:pageId/:tab'
        />
        <Redirect exact={true} from='/email-marketing/summary' to='/marketing/email/summary' />
        <Redirect
            exact={true}
            from='/email-marketing/sender-address'
            to='/marketing/sender-address'
        />
    </Switch>
);
